module.exports = __webpack_public_path__ + "static/media/contract-cancel-icon.e85a8218.svg";